import React, { useEffect, useState } from "react";
import CommonList from "src/views/common/CommonList";
import Auth from "src/auth";
import {
  apiCall,
  apiCallResponse,
  apiCallSPGet,
  apiCallSPPost,
  apiDownloadDocument,
} from "src/_apiConfig/apiCall";
import {
  CommonSearchExtra,
  SCSelect,
  updateSearchStatus,
} from "src/views/common/CommonSearch";
import { CRow } from "@coreui/react";
import ToastMessage from "src/_components/ToastMessage";
import { AlertResponse, addToastError } from "src/_constants/alert.type";
import CustomeModalPopup from "src/views/common/CustomeModalPopup";
import {
  CommonBtn,
  ControlFileUpload,
  DetailRowOnly,
} from "src/views/common/Common";
import TableButtonClick from "src/views/common/Table/TableButtonClick";
import ConfirmationPopup from "src/views/common/ConfirmationPopup";

const LotInvoiceList = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  //const [isExporting, setIsExporting] = useState(false); //Export To Excel Loader Manage

  const [toasts, setToasts] = useState(AlertResponse); //Toasts Message

  const [itemsCollectionSeason, setItemsCollectionSeason] = useState([]);
  const [itemsTenderNo, setItemsTenderNo] = useState([]);
  const [itemsLotNo, setItemsLotNo] = useState([]);

  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);

  const [DocumentSelectedFile, setDocumentSelectedFile] = useState();
  const [DocumentFileEvent, setDocumentFileEvent] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [paymentId, setPaymentId] = useState(0);
  const SearchFilterModel = {
    collectionSeason:  new Date().getFullYear().toString(),
    tenderId: 0,
    lotId: 0,
  };
  // Search Model
  const [search, setSearch] = useState(SearchFilterModel);

  // Page  API URL manage
  const ListUrl = `LotDetails/Invoice/List`;

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    return JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      collection_season: Number(search.collectionSeason),
      tender_id: Number(search.tenderId),
      lot_id: Number(search.lotId),
      user_id: authenticated.userId,
    });
  };

  useEffect(() => {
    if (authenticated && authenticated.userId > 0) {
      paggingManage(0);
      setloading(true);
      reset();
      getTenderCollectionSeasonDrop();
      getTenderDetails();
      getLotDetails();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit]);

  useEffect(() => {
    if (isSearch) {
      getList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Disabled Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  const getTenderCollectionSeasonDrop = async () => {
    await apiCallResponse(`Tender/GetTenderCollectionSeason`, "GET").then(
      (res) => {
        if (res.success) setItemsCollectionSeason(res.data);
        else setItemsCollectionSeason([]);
      }
    );
  };
  const getTenderDetails = async (CollectionSeason = "") => {
    CollectionSeason =
      CollectionSeason !== "" && CollectionSeason !== undefined
        ? CollectionSeason
        : 0;

    await apiCallSPGet(
      `Tender/Dropdown_TenderList?Collection_season=${CollectionSeason}`
    ).then((res) => {
      if (res.success) setItemsTenderNo(res.data);
      else setItemsTenderNo([]);
    });
  };
  const getLotDetails = async (TenderId = "") => {
    TenderId = TenderId !== "" && TenderId !== undefined ? TenderId : 0;

    await apiCallSPGet(
      `LotDetails/Dropdown_LotList?Tender_id=${TenderId}&User_id=${authenticated.userId}`
    ).then((res) => {
      if (res.success) setItemsLotNo(res.data);
      else setItemsLotNo([]);
    });
  };
  // get Report List
  const getList = async () => {
    if (
      authenticated &&
      authenticated.userId > 0 &&
      (Number(search.collectionSeason) > 0 ||
        Number(search.tenderId) > 0 ||
        Number(search.lotId) > 0)
    ) {
      setloading(true);
      paggingDisabled();
      setUsersData();

      await apiCallSPPost(ListUrl, getdata(), [])
        .then((res) => {
          if (res.success) {
            setUsersData(res.data);

            //if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingManage(res.totalRecord);
            //}
          } else {
            setUsersData();
            paggingManage(0, false);
            //alert(res.message);
          }
        })
        .finally(() => {
          setloading(false);
        });
    } else {
      paggingDisabled();
      setUsersData([]);
      setloading(false);
    }
  };

  const reset = () => {
    setpageLimit(0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);

    setSearch({ ...search, ...SearchFilterModel });

    setUsersData();
  };

  const handleChangeTenderCollectionSeason = (e) => {
    const value = e.target.value;
    updateSearch(e, "tenderId", "");
    updateSearch(e, "LotId", 0);
    setItemsTenderNo([]);
    setItemsLotNo([]);
    getTenderDetails(value);
  };
  const handleChangeLotCollectionSeason = (e) => {
    const value = e.target.value;
    updateSearch(e, "LotId", 0);
    setItemsLotNo([]);
    getLotDetails(value);
  };

  const searchControl = (
    <>
      <SCSelect
        labelname="Collection Season"
        name="collectionSeason"
        value={search.collectionSeason}
        onChange={handleChangeTenderCollectionSeason}
        items={itemsCollectionSeason.map((item, key) => ({
          value: item.collectionSeason,
          label: item.collectionSeason,
        }))}
      />
      <SCSelect
        labelname="Tender Number"
        name="tenderId"
        value={search.tenderId}
        onChange={(e) => handleChangeLotCollectionSeason(e)}
        items={itemsTenderNo
          //.sort((a, b) => b.tenderNo.localeCompare(a.tenderNo))
          .map((item, key) => ({
            value: item.tenderId,
            label: item.tenderNo,
          }))}
      />
      <SCSelect
        labelname="Lot Number"
        name="lotId"
        value={search.lotId}
        onChange={updateSearch}
        items={itemsLotNo
          //.sort((a, b) => b.tenderNo.localeCompare(a.tenderNo))
          .map((item, key) => ({
            value: item.lotId,
            label: item.lotNo,
          }))}
      />
    </>
  );

  const OpenUploadPopup = (paymentId) => {
    setPaymentId(paymentId);
    setShowModal(true);
  };
  const handleCofirmationOpen = async (id) => {
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpId(1);
    setPaymentId(id);
  };
  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);

  const SubmitConfirmationPopUpResponse = async () => {
    setShowModal(true);
    setCPopUpIndex(-1);
    handleConfirmationPopUpModalClose();
  };

  const InvoiceDownload = async (paymentId, mrno) => {
    const header = new Headers();
    await apiDownloadDocument(
      mrno + ".pdf",
      `LotDetails/Invoice/Download?id=${paymentId}`,
      "GET",
      header,
      null
    ).then((res) => {
      if (!res.success) alert(res.message);
      //else alert(res.message);
    });
  };
  const scopedSlotsCommon = {
    downloadInvoice: (item, index) => {
      return (
        <td className="py-2 ">
          <CommonBtn
            isDisplayAllow={parseInt(item.invoiceStatusId) === 1}
            className={"ml-1"}
            buttonName={"Download"}
            onClick={(e) => {
              InvoiceDownload(item.paymentId, item.mrNo);
            }}
          />
        </td>
      );
    },
    actionSet: (item, index) => {
      return (
        <td className="py-2 ">
          <CommonBtn
            isDisplayAllow={true}
            buttonName={"Upload"}
            //isButtonLoader={true}
            onClick={() => {
              parseInt(item.invoiceStatusId) === 1
                ? handleCofirmationOpen(item.paymentId)
                : OpenUploadPopup(item.paymentId);
            }}
          />
        </td>
      );
    },
  };
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isLotNumberDisplay={true}
    />
  );
  // List Header And data bind
  const fields = [
    {
      key: "srNo",
      _style: { width: "5%" },
      label: "S.N.",
    },
    {
      key: "collectionSeason",
      _style: { width: "5%" },
      label: "Collection Season.",
    },

    {
      key: "tenderNo",
      _style: { width: "5%" },
      label: "Tender No",
    },
    {
      key: "lotNo",
      _style: { width: "5%" },
      label: "Lot No",
    },
    {
      key: "paymentType",
      _style: { width: "15%" },
      label: "Payment Type",
    },
    {
      key: "paymentComplete",
      _style: { width: "7.5%" },
      label: "Installment",
    },

    {
      key: "amount",
      _style: { width: "5%" },
      label: "Amount",
    },
    {
      key: "mrDate",
      _style: { width: "13.5%" },
      label: "MR Date",
    },
    {
      key: "mrNo",
      _style: { width: "5%" },
      label: "MR No.",
    },

    {
      key: "invoiceStatus",
      _style: { width: "7.5%" },
      label: "Invoice Status",
    },
    {
      key: "invoiceUploadedDate",
      _style: { width: "12.5%" },
      label: "Invoice Uploaded Date",
    },
    {
      key: "invoiceUploadedByName",
      _style: { width: "15%" },
      label: "Invoice Uploaded By",
    },
    {
      key: "downloadInvoice",
      _style: { width: "15%" },
      label: "Download",
    },
  ];
  if (authenticated.role === "DFO") {
    fields.push({
      key: "actionSet",
      label: "Action",
      sorter: false,
      filter: false,
    });
  }

  const handleClose = (event, reason) => {
    // if (reason === "escapeKeyDown") {
    //   console.log("ddd", "escapeKeyDown");
    // }
    // if (reason === "backdropClick") {
    //   console.log("ddd", "backdropClick");
    // }
    if (reason !== "backdropClick") {
      hideModal();
    }
  };
  const hideModal = () => setShowModal(false);

  const SubmitConfirmation = async (e) => {
    e.preventDefault();
    if (DocumentSelectedFile === null || DocumentSelectedFile === undefined) {
      alert("Please upload Invoice");
    } else if (
      DocumentSelectedFile != null &&
      DocumentSelectedFile !== undefined &&
      DocumentFileEvent !== null
    ) {
      const file = DocumentFileEvent.target.files[0];
      const allowedTypes = [
        "application/pdf",
        // "image/png",
        // "image/jpg",
        // "image/jpeg",
      ];

      if (!allowedTypes.includes(file.type)) {
        addToastError(setToasts, "Please upload only PDF files!");
      } else if (file.size > 2 * 1024 * 1024) {
        // 2MB in bytes
        addToastError(
          setToasts,
          "File size exceeds 2MB. Please upload a smaller file."
        );
      } else {
        let file = DocumentSelectedFile;
        let etaxfileevent = DocumentFileEvent;
        if (etaxfileevent !== false) {
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");

          formData.append("file", file);

          const url = `LotDetails/Invoice/Upload/${paymentId}/${authenticated.userId}`;
          //   await apiCallSPPost(url, formData, header).then((res) => {
          //     console.log("Response:", res);
          //     if (res.success) {
          //       // Assuming these functions update state variables in your React component
          //       setDocumentSelectedFile();
          //       setDocumentFileEvent(false);
          //       hideModal();
          //       getList();
          //     } else {
          //       //addToastError(setToasts, res.message);

          //       // Handle error scenarios
          //     }
          //   });
          // }
          const response = await apiCall(url, "POST", header, formData);
          const data1 = await response.text();

          if (response.status === 200) {
            setDocumentSelectedFile();
            setDocumentFileEvent(false);
            //alert(response.message);
            hideModal();
            getList();
          } else {
            alert("Error to upload file!");
          }
        } else {
          alert("File error");
        }
      }
    }
  };
  return (
    <>
      <ToastMessage toasts={toasts} setToasts={setToasts} />

      <CommonList
        items={usersData}
        fields={fields}
        scopedSlots={scopedSlotsCommon}
        listName="Invoice List"
        loading={loading}
        prev={prevButton}
        next={nextButton}
        disabledprev={disabledprev}
        disablednext={disablednext}
        additional={additional}
      />

      <ConfirmationPopup
        showModal={CPopUpDisplayConfirmationModal}
        hideModal={handleConfirmationPopUpModalClose}
        confirmModal={SubmitConfirmationPopUpResponse}
        id={CPopUpId}
        index={CPopUpIndex}
        ModalBody={"Are you sure you want to Remove Invoice?"}
        //ModalTitle={CPopUpTitle}
        confirmButtonCss="btn btn-danger"
        //ButtonLoader={CPopUpButtonLoader}
      />
      <CustomeModalPopup
        onOpen={showModal}
        onClose={handleClose}
        onSubmitButton={SubmitConfirmation}
        onCloseButton={handleClose}
        isSubmitBtnDisabled={false}
        isFromSubmit={true}
        popupWith={520}
        btnCColstyle={{ textAlign: "right" }}
        body={
          <>
            <DetailRowOnly body={"Upload Invoice"} />

            <hr />

            <CRow className="mb-3">
              <ControlFileUpload
                displayUploadController={true}
                isRequired={true}
                label={"Upload Invoice"}
                name="invoiceDocument"
                id="invoiceDocument"
                className="col-xs-12 "
                selectedFile={DocumentSelectedFile}
                onChange={(e) => {
                  setDocumentFileEvent(e);
                  setDocumentSelectedFile(e.target.files[0]);
                  e.preventDefault();
                }}
                //errorMessage={formState.support_document.errors}
              />
            </CRow>
          </>
        }
      />
    </>
  );
};

export default LotInvoiceList;
